import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * Unwind accidental multiple URL-encoding (e.g. %2520) before URLSearchParams encodes once.
 */
export function normalizeUrlQueryValue(value) {
  if (value == null || value === '') {
    return value;
  }

  var current = value;

  for (var attempt = 0; attempt < 5; attempt += 1) {
    if (!/%[0-9A-Fa-f]{2}/.test(current)) {
      break;
    }

    try {
      var decoded = decodeURIComponent(current);

      if (decoded === current) {
        break;
      }

      current = decoded;
    } catch (_unused) {
      break;
    }
  }

  return current;
}
export var PathBuilder = /*#__PURE__*/function () {
  function PathBuilder() {
    _classCallCheck(this, PathBuilder);

    _defineProperty(this, "_basePath", void 0);

    _defineProperty(this, "_segments", []);

    _defineProperty(this, "queryParams", {});
  }

  _createClass(PathBuilder, [{
    key: "withBasePath",
    value: function withBasePath(basePath) {
      this._basePath = basePath;
      return this;
    }
  }, {
    key: "withQueryParam",
    value: function withQueryParam(key, value) {
      this.queryParams[key] = value;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      var path = [this._basePath].concat(_toConsumableArray(this._segments)).join('/');
      var normalizedParams = Object.fromEntries(Object.entries(this.queryParams).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        return [key, normalizeUrlQueryValue(val)];
      }));
      var queryString = new URLSearchParams(normalizedParams).toString();
      return queryString ? "".concat(path, "?").concat(queryString) : path;
    }
  }]);

  return PathBuilder;
}();